import { useState } from 'react';
import { EyeIcon, ArrowDownTrayIcon, CalendarIcon } from '@heroicons/react/24/outline';
import ExportModal from '../components/ExportModal';

const Estudiantes = () => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [estudiantes] = useState([
    {
      id: 1,
      nombre: 'Carlos Mendoza Ruiz',
      carrera: 'Ciencias de la Comunicación',
      telefono: '+51955864159',
      puntaje: 85,
      fecha: '21/3/2025',
      estado: 'Activo'
    },
    {
      id: 2,
      nombre: 'María Fernanda Torres',
      carrera: 'Arquitectura',
      telefono: '+51944494922',
      puntaje: 78,
      fecha: '19/3/2025',
      estado: 'Activo'
    },
    {
      id: 3,
      nombre: 'Juan Diego Velasco',
      carrera: 'Marketing',
      telefono: '+51950999940',
      puntaje: 72,
      fecha: '15/3/2025',
      estado: 'Inactivo'
    },
    {
      id: 4,
      nombre: 'Andrea López Castro',
      carrera: 'Psicología',
      telefono: '+51958074779',
      puntaje: 65,
      fecha: '12/3/2025',
      estado: 'Activo'
    },
    {
      id: 5,
      nombre: 'Sebastian Franco',
      carrera: 'Administración',
      telefono: '+51931828996',
      puntaje: 68,
      fecha: '11/3/2025',
      estado: 'Activo'
    }
  ]);

  const handleExport = (selectedFields) => {
    // Here you would implement the CSV export logic
    console.log('Exporting with fields:', selectedFields);
    setIsExportModalOpen(false);
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Estudiantes</h1>
          <p className="mt-2 text-sm text-gray-600">
            Visualiza el progreso y métricas de empleabilidad de tus estudiantes
          </p>
        </div>
      </div>

      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        {/* Filtros */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-gray-50">
          <div className="max-w-sm">
            <input
              type="text"
              placeholder="Buscar estudiantes..."
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setIsExportModalOpen(true)}
              className="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              <ArrowDownTrayIcon className="h-5 w-5 mr-2" />
              Exportar seleccionadas
            </button>
            <button
              className="inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <CalendarIcon className="h-5 w-5 mr-2" />
              Seleccionar fechas
            </button>
            <select className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
              <option>Todos</option>
              <option>Activos</option>
              <option>Inactivos</option>
            </select>
          </div>
        </div>

        {/* Tabla */}
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Nombre
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Carrera
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Teléfono
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Puntaje
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Fecha
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Estado
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {estudiantes.map((estudiante) => (
                <tr key={estudiante.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {estudiante.nombre}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {estudiante.carrera}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <a
                      href={`https://wa.me/${estudiante.telefono.replace('+', '')}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center text-gray-600 hover:text-green-600"
                    >
                      {estudiante.telefono}
                      <svg className="w-4 h-4 ml-1 text-green-500" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.964 9.964 0 001.333 4.993L2 22l5.233-1.237a9.994 9.994 0 004.779 1.217h.004c5.505 0 9.988-4.478 9.989-9.984 0-2.669-1.037-5.176-2.922-7.062A9.935 9.935 0 0012.012 2zm-3.706 8.416a.557.557 0 01-.089-.003c-.398-.083-1.037-.383-1.553-.899-.516-.516-.816-1.155-.899-1.553a.567.567 0 01.564-.683c.398 0 .815.166 1.053.404.238.238.404.655.404 1.053 0 .311-.251.562-.562.562h-.006a.557.557 0 01.088.119zm6.406 6.406c-.311 0-.562-.251-.562-.562 0-.398.166-.815.404-1.053.238-.238.655-.404 1.053-.404.311 0 .562.251.562.562 0 .398-.166.815-.404 1.053-.238.238-.655.404-1.053.404zm3.294-3.294c-.083.398-.383 1.037-.899 1.553-.516.516-1.155.816-1.553.899a.567.567 0 01-.683-.564c0-.398.166-.815.404-1.053.238-.238.655-.404 1.053-.404.311 0 .562.251.562.562v.006a.557.557 0 01.116.001z"/>
                      </svg>
                    </a>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {estudiante.puntaje}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {estudiante.fecha}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      estudiante.estado === 'Activo' 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {estudiante.estado}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <button className="text-gray-400 hover:text-blue-600 transition-colors">
                      <EyeIcon className="h-5 w-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Paginación */}
        <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
          <div className="flex-1 flex justify-between sm:hidden">
            <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
              Anterior
            </button>
            <button className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
              Siguiente
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
            <div>
              <p className="text-sm text-gray-700">
                Mostrando <span className="font-medium">1</span> a <span className="font-medium">5</span> de{' '}
                <span className="font-medium">20</span> resultados
              </p>
            </div>
            <div>
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                <button className="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                  Anterior
                </button>
                <button className="relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                  Siguiente
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <ExportModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        onExport={handleExport}
      />
    </div>
  );
};

export default Estudiantes; 